export const generateAttachmentId = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, '0');

export const getShotFileName = (name: string) => {
    if (name.length < 12) {
        return name;
    }

    const parts = name.split('.');

    const extension = parts.pop();

    const fileName = parts.join('.');

    return `${fileName.slice(0, 7)}...${fileName[fileName.length - 1]}.${extension}`;
};
